import type { TradeUnionType } from './career-track';
import type { CompanySize, JobArchitecture } from './job-architecture';
import type { HttpFetcherWithBaseUrl } from '../../../shared/source/http-fetcher';
import type Maybe from 'true-myth/maybe';
import type Result from 'true-myth/result';

export type SendJobArchitectureMetadata = (
    jobArchitecture: JobArchitecture,
    options: {
        readonly careerTrackTypes: Maybe<readonly TradeUnionType[]>;
        readonly companyDescription: Maybe<string>;
        readonly companyPriorities: Maybe<string>;
        readonly companySize: Maybe<CompanySize>;
        readonly executiveRolesInTheirOwnJobFamily: Maybe<boolean>;
    },
) => Promise<Result<unknown, Error>>;

export const createSendJobArchitectureMetadata = (dependencies: {
    readonly cobrainerApiFetcher: HttpFetcherWithBaseUrl;
}): SendJobArchitectureMetadata => {
    const { cobrainerApiFetcher } = dependencies;

    return (jobArchitecture, options) => {
        const {
            careerTrackTypes,
            companyDescription,
            companyPriorities,
            companySize,
            executiveRolesInTheirOwnJobFamily,
        } = options;

        return cobrainerApiFetcher.patchJson({
            pathname: `/job-architectures/${jobArchitecture.id}/metadata`,
            payload: {
                careerTrackTypes: careerTrackTypes.unwrapOr(undefined),
                companyDescription: companyDescription.unwrapOr(undefined),
                companyExecutiveRolesInFamily: executiveRolesInTheirOwnJobFamily.unwrapOr(false),
                companyPriorities: companyPriorities.unwrapOr(undefined),
                companySize: companySize.unwrapOr(undefined),
            },
        });
    };
};
